export default "__VITE_ASSET__qrVE2atU__"